import * as React from "react";
import Paper from "@mui/material/Paper";
import { Button } from "@mui/material";
import { Box } from "@mui/system";
import { Props } from "../../../pages/Crew/Departure/Create/types";
import Detail from "../../../organisms/Owner/Departure/Detail";

type ConfirmProps = Props & {
  reportId: number;
  onBack(): void;
};

const DepartureDetail = (props: ConfirmProps): React.ReactElement => {
  const onClickBack = () => {
    props.onBack();
  };

  return (
    <React.Fragment>
      <Paper sx={{ backgroundColor: "#ECEEF2", borderRadius: "20px" }}>
        <Detail
          isPreview={true}
          form={props.form}
          reportId={props.reportId}
          pageTitle={"Departure Report"}
        />

        <Box
          sx={{
            textAlign: "left",
            px: 2,
            py: 4,
          }}
        >
          <Button
            sx={{
              mx: 2,
              width: "200px",
              color: "#FFFFFF",
              backgroundColor: "#20BE89  !important",
              fontFamily: "Public Sans",
              "&.MuiButton-root": {
                fontFamily: "Public Sans",
              },
              textTransform: "none",
            }}
            variant="contained"
            onClick={onClickBack}
          >
            Back
          </Button>
        </Box>
      </Paper>
    </React.Fragment>
  );
};

export default DepartureDetail;
